import React from 'react';

export default function Home() {

  return (
    <div className="bg-white">
      {/* Hero section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-survivor-gradient"></div>
        <div className="relative max-w-7xl mx-auto py-48 px-4 sm:py-64 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl md:text-6xl">
              <span className="block text-survivor-200">🏝️ Outwit • Outplay • Outlast</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}
